import { h } from 'preact';

import { BaseAnnotation } from "../base_annotation";

//The purpose of this annotation is essentially to allow certain actions, like atStartTime
//to fire properly at the correct times. 
export class Phantom extends BaseAnnotation {
    constructor(props) {
        super(props);
    };

    render() {
        return (
            <div {...this.applyActions(this.props.actions)}></div>
        );
    };
};
